import { render, staticRenderFns } from "./afterSalesDetails.vue?vue&type=template&id=5c7ff201&scoped=true&"
import script from "./afterSalesDetails.vue?vue&type=script&lang=js&"
export * from "./afterSalesDetails.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesDetails.vue?vue&type=style&index=0&id=5c7ff201&prod&lang=scss&scoped=true&"
import style1 from "./afterSalesDetails.vue?vue&type=style&index=1&id=5c7ff201&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ff201",
  null
  
)

export default component.exports